import { useRef, useState } from 'react';
import { BookMarked } from 'lucide-react';
import VorlagenAuswahl from './VorlagenAuswahl';
import { VORLAGEN_TEXTE as T } from './vorlagenTexte';
import './vorlagen.css';

// Profil-Nachbau F-20 Ergänzung 3 (BAU-VORLAGEN.md 4, 5.1, 5.2): der Knopf „Vorlage einfügen“ für das Feld der Startseite (mit
// Text) und das Nachfrage-Feld der Recherche (nur Symbol, Name in aria-label und title). Er öffnet die Auswahl und bekommt den
// Fokus zurück, wenn sie ohne Wahl schließt. onWahl läuft nach dem Schließen: Der Aufrufer setzt den Text, fokussiert sein Feld
// und markiert nach dem nächsten Rendern den ersten Platzhalter (ersterPlatzhalter aus vorlagenTexte.ts).
// Symbol aus lucide-react wie die übrigen Symbole der Vorlagen (Folder, EyeOff, Users); die Knöpfe neben dem Nachfrage-Feld
// („Senden“, „Abbrechen“) tragen keines.
export function VorlagenKnopf({ mitText, feldHatText, onWahl, disabled }: { mitText: boolean; feldHatText: boolean;
  onWahl: (v: { titel: string; text: string }) => void; disabled?: boolean }) {
  const [offen, setOffen] = useState(false);
  const knopf = useRef<HTMLButtonElement>(null);
  return <>
    <button ref={knopf} type="button" className={mitText ? 'vorlagen-einfuegen' : 'vorlagen-einfuegen vorlagen-einfuegen--symbol'}
      disabled={disabled} aria-haspopup="dialog" aria-expanded={offen} onClick={() => setOffen(true)}
      {...(mitText ? {} : { 'aria-label': T.einfuegen, title: T.einfuegen })}>
      <BookMarked size={16} aria-hidden="true" />{mitText && <span>{T.einfuegen}</span>}
    </button>
    <VorlagenAuswahl offen={offen} feldHatText={feldHatText} onWahl={onWahl} onSchliessen={() => setOffen(false)} ausloeser={knopf} />
  </>;
}
